import styled from "@emotion/styled";
import { keyframes } from "@emotion/react";
import { Box } from "@otrium/core";

const slideUp = keyframes`
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
`;

export const PopupContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  padding: 32px;
`;

export const MobilePopupContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  padding: 16px;
`;

export const PopupHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
`;

export const ProductInfoWrapper = styled.div`
  display: flex;
  gap: 16px;
  padding: 16px 0 24px;
`;

export const ProductImage = styled.img`
  width: 100px;
  height: 150px;
  object-fit: contain;
  flex-shrink: 0;
`;

export const ProductDetails = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding-top: 13px;
`;

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ButtonWrapper = styled.div<{ isMobile?: boolean }>`
  margin-top: ${({ isMobile }) => (isMobile ? "16px" : "8px")};
`;

export const DesktopPopupWrapper = styled(Box)`
  width: 444px;
  max-width: 90vw;
  background: ${({ theme }) => theme.colors.tone.white};
  border-radius: 8px;
  overflow: hidden;
`;

export const MobilePopupWrapper = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  box-shadow: 0 -4px 8px 0 ${({ theme }) => theme.effects.overlay.black_10};
  border-radius: 16px 16px 0 0;
  background-color: ${({ theme }) => theme.colors.tone.white};
  display: flex;
  flex-direction: column;
  overflow: hidden;
  z-index: ${({ theme }) => theme.zIndex.drawer + 1};
  animation: ${slideUp} 0.3s ease;
`;

export const MobileOverlay = styled.div<{ isOpen: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: ${({ theme }) => theme.zIndex.drawer};
  opacity: ${({ isOpen }) => (isOpen ? 1 : 0)};
  visibility: ${({ isOpen }) => (isOpen ? "visible" : "hidden")};
  transition: opacity 0.3s ease, visibility 0.3s ease;
`;

export const SuccessToast = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 14px 12px;
  background-color: #c8f2cc;
  font-weight: 600;
  line-height: 20px;
  border-radius: 8px;
`;
